<template>
  <div class="content-box">
    <Title />
    <div class="title-right">
      <el-link href="/zt/wjszjnj/" target='_blank'>
        <img src="//imgs-b2b.100ec.cn//Public/attached/2026/08/13/6a7d55c773ae9.gif"
      /></el-link>
    </div>

    <!-- 左侧大类 + 右侧标签 两栏布局 -->
    <div class="bc-tag-nav">
      <!-- 左侧大类列 -->
      <div class="bc-col-left">
        <span class="bc-cat" :class="{ active: activeCategory === 0 }" @click="changeCategory(0)">行业</span>
        <span class="bc-cat" :class="{ active: activeCategory === 1 }" @click="changeCategory(1)">大模型</span>
        <span class="bc-cat" :class="{ active: activeCategory === 2 }" @click="changeCategory(2)">AI 企业</span>
        <span class="bc-cat" :class="{ active: activeCategory === 3 }" @click="changeCategory(3)">AI 应用</span>
      </div>

      <!-- 右侧标签区（始终全部渲染） -->
      <div class="bc-col-right">
        <div class="bc-tag-row" :class="{ active: activeCategory === 0 }">
          <span v-for="(i, index) in dataNavRow1" :key="index"
            :class="['bc-tag', { active: activeCategory === 0 && activeIndex === String(index) }]"
            @click="handleSelect(index, 0)">{{ i.label }}</span>
        </div>
        <div class="bc-tag-row" :class="{ active: activeCategory === 1 }">
          <span v-for="(i, index) in dataNavRow2" :key="index"
            :class="['bc-tag', { active: activeCategory === 1 && activeIndex === String(index) }]"
            @click="handleSelect(index, 1)">{{ i.label }}</span>
        </div>
        <div class="bc-tag-row" :class="{ active: activeCategory === 2 }">
          <span v-for="(i, index) in dataNavRow3" :key="index"
            :class="['bc-tag', { active: activeCategory === 2 && activeIndex === String(index) }]"
            @click="handleSelect(index, 2)">{{ i.label }}</span>
        </div>
        <div class="bc-tag-row" :class="{ active: activeCategory === 3 }">
          <span v-for="(i, index) in dataNavRow4" :key="index"
            :class="['bc-tag', { active: activeCategory === 3 && activeIndex === String(index) }]"
            @click="handleSelect(index, 3)">{{ i.label }}</span>
        </div>
      </div>
    </div>

    <div class="mobile-select">
      <el-select v-model="name" @change="handleSelect2">
        <el-option v-for="item in dataNav" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </div>

    <Textlist />
  </div>
</template>

<script>
export default {
  name: "broadCast",
  data() {
    return {
       activeCategory: 0, // 当前激活的类别 0:行业 1:模型 2:AI 企业 3:AI 应用
      activeIndex: "0", // 当前激活的子项索引
      name: "滚动播报",
      categoryNames: ['行业', '大模型', 'AI 企业', 'AI 应用'],
      dataNav: [
        {
          value: "AI",
          label: "滚动播报",
        },
        {
          value: "人工智能",
          label: "人工智能",
        },
        {
          value: "大模型",
          label: "大模型",
        },
        {
          value: "智能体",
          label: "智能体",
        },
        {
          value: "机器人",
          label: "机器人",
        },
        {
          value: "具身智能",
          label: "具身智能",
        },
        {
          value: "Deepseek",
          label: "Deepseek",
        },
         {
          value: "chatgpt",
          label: "chatgpt",
        },
        {
          value: "豆包",
          label: "豆包",
        },
        {
          value: "元宝",
          label: "元宝",
        },
        {
          value: "千问",
          label: "千问",
        },
        {
          value: "文心一言",
          label: "文心一言",
        },
        {
          value: "openclaw",
          label: "openclaw",
        },
        {
          value: "KIMI",
          label: "KIMI",
        },
        {
          value: "阿里 AI",
          label: "阿里",
        },
        {
          value: "腾讯 AI",
          label: "腾讯",
        },
        {
          value: "字节 AI",
          label: "字节跳动",
        },
        {
          value: "百度 AI",
          label: "百度",
        },
        {
          value: "美团 AI",
          label: "美团",
        },
        {
          value: "快手 AI",
          label: "快手",
        },
        {
          value: "京东 AI",
          label: "京东",
        },

      ],
       dataNavRow1: [], // 行业
      dataNavRow2: [], // 模型
      dataNavRow3: [], // AI 企业
      dataNavRow4: [], // AI 应用
      params: {
        json: 0,
        filter: [
          // "【",
          "研报",
          "分析",
          "（PPT）",
          "（全文）",
          "曹磊",
          "张周平",
          "董毅智",
          "赵占领",
          "李旻",
        ],
      },
    };
  },
  created() {
    // this.$store.commit("textparams", this.params);
    // this.$store.commit("changeKeys", this.dataNav[0].value);
    // this.$store.dispatch("getText");
    // 拆分三行数据
  // 定义三大类导航数据
    // 定义三大类导航数据
    const industryData = [
      { value: "AI", label: "滚动播报" },
      { value: "人工智能", label: "人工智能" },
      { value: "大模型", label: "大模型" },
      { value: "智能体", label: "智能体" },
      { value: "机器人", label: "机器人" },
      { value: "具身智能", label: "具身智能"},
      { value: "算法 数据", label: "算法" }

    ];
    
    const modelData = [
      { value: "Deepseek", label: "Deepseek" },
      { value: "豆包", label: "豆包" },
      { value: "元宝", label: "元宝" },
      { value: "千问", label: "千问" },
      { value: "文心一言", label: "文心一言" },
      { value: "openclaw", label: "openclaw" },
      { value: "KIMI", label: "KIMI" },
      { value: "chatgpt", label: "chatgpt" }

    ];
    
    const companyData = [
      { value: "阿里 AI", label: "阿里" },
      { value: "腾讯 AI", label: "腾讯" },
      { value: "字节 AI", label: "字节跳动" },
      { value: "华为 AI", label: "华为" },

      { value: "百度 AI", label: "百度" },
      { value: "美团 AI", label: "美团" },
      { value: "快手 AI", label: "快手" },
      { value: "京东 AI", label: "京东" },
      { value: "支付宝 AI", label: "支付宝" }

    ];
    
    const appData = [
      { value: "AI 零售", label: "零售" },
      { value: "AI 跨境", label: "跨境" },
      { value: "AI 教育", label: "教育" },
      { value: "AI 健康", label: "健康" },
      { value: "AI 出行", label: "出行" },
      { value: "AI 生活", label: "生活" },
      { value: "AI 产业", label: "产业" },
      { value: "AI 物流", label: "物流" },
      { value: "AI 金融", label: "金融" }


    ];
    
    this.dataNavRow1 = industryData;
    this.dataNavRow2 = modelData;
    this.dataNavRow3 = companyData;
    this.dataNavRow4 = appData;

    this.$store.commit("textparams", this.params);
    this.$store.commit("changeKeys", this.dataNav[0].value);
    this.$store.dispatch("getText");
  },
  methods: {
    // handleSelect(index) {
    //   if (typeof this.dataNav[index].value == "number") {
    //     this.params.json = 2;
    //   } else {
    //     this.params.json = 0;
    //   }
    //   this.$store.commit("textparams", this.params);
    //   this.$store.commit("changeKeys", this.dataNav[index].value);
    //   this.$store.dispatch("getText");
    // },
    // handleSelect2(value) {
    //   if (typeof value == "number") {
    //     this.params.json = 2;
    //   } else {
    //     this.params.json = 0;
    //   }
    //   this.$store.commit("textparams", this.params);
    //   this.$store.commit("changeKeys", value);
    //   this.$store.dispatch("getText");
    // },
   // 切换类别
    changeCategory(categoryIndex) {
      this.activeCategory = categoryIndex;
      this.activeIndex = "0"; // 重置子项索引为第一个
      
      // 加载对应类别的第一个数据
      let firstValue;
      if (categoryIndex === 0) {
        firstValue = this.dataNavRow1[0].value;
      } else if (categoryIndex === 1) {
        firstValue = this.dataNavRow2[0].value;
      } else if (categoryIndex === 2) {
        firstValue = this.dataNavRow3[0].value;
      } else {
        firstValue = this.dataNavRow4[0].value;
      }
      
      this.$store.commit("changeKeys", firstValue);
      this.$store.dispatch("getText");
    },
    
    handleSelect(index, categoryIndex = 0) {
      this.activeCategory = categoryIndex;
      this.activeIndex = String(index);

      let selectedItem;
      if (categoryIndex === 0) {
        selectedItem = this.dataNavRow1[index];
      } else if (categoryIndex === 1) {
        selectedItem = this.dataNavRow2[index];
      } else if (categoryIndex === 2) {
        selectedItem = this.dataNavRow3[index];
      } else {
        selectedItem = this.dataNavRow4[index];
      }

      if (typeof selectedItem.value == "number") {
        this.params.json = 2;
      } else {
        this.params.json = 0;
      }
      this.$store.commit("textparams", this.params);
      this.$store.commit("changeKeys", selectedItem.value);
      this.$store.dispatch("getText");
    },
     handleSelect2(value) {
      // 根据值找到对应的索引
      const index = this.dataNav.findIndex(item => item.value === value);
      if (index !== -1) {
        this.activeIndex = String(index);
      }

      if (typeof value == "number") {
        this.params.json = 2;
      } else {
        this.params.json = 0;
      }
      this.$store.commit("textparams", this.params);
      this.$store.commit("changeKeys", value);
      this.$store.dispatch("getText");
    },
  },
};
</script>
<style scoped>
.title {
  position: relative;
}

.title-right {
  position: absolute;
  left: 195px;
  top: 65px;
}

.title-right img {
  width: 520px;
  height: 70px;
}

/* 分类标签导航 - 左大类 + 右标签 两栏 */
.bc-tag-nav {
  display: flex;
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 16px;
}

/* 左侧大类列 */
.bc-col-left {
  flex: 0 0 90px;
  background: #fafafa;
  border-right: 1px solid #e4e7ed;
  display: flex;
  flex-direction: column;
}

.bc-cat {
  padding: 14px 10px;
  font-size: 15px;
  font-weight: bold;
  color: #606266;
  cursor: pointer;
  text-align: center;
  border-bottom: 1px solid #e4e7ed;
  transition: all .2s;
  user-select: none;
}

.bc-cat:last-child {
  border-bottom: none;
}

.bc-cat:hover {
  color: #ff6200;
  background: #fff7f0;
}

.bc-cat.active {
  color: #fff;
  background: #ff6200;
}

/* 右侧标签列 */
.bc-col-right {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.bc-tag-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 12px 16px;
  border-bottom: 1px solid #ebeef5;
  transition: background .2s;
}

.bc-tag-row:last-child {
  border-bottom: none;
}

.bc-tag-row.active {
  background: #fafafa;
}

.bc-tag {
  padding: 5px 14px;
  font-size: 13px;
  color: #606266;
  background: #f4f4f5;
  border-radius: 4px;
  cursor: pointer;
  transition: all .2s;
  line-height: 1.6;
}

.bc-tag:hover {
  color: #ff6200;
  background: #fff2e6;
}

.bc-tag.active {
  color: #fff;
  background: #ff6200;
}

.mobile-select {
  display: none;
  margin-bottom: 12px;
}

@media (max-width: 1100px) {
  .title-right {
    position: static;
    margin: 10px 0;
  }

  .title-right img {
    width: 100%;
    height: 50px;
  }
}

@media (max-width: 868px) {
  .bc-tag-nav {
    flex-direction: column;
  }

  .bc-col-left {
    flex-direction: row;
    flex: none;
    border-right: none;
    border-bottom: 1px solid #e4e7ed;
  }

  .bc-cat {
    flex: 1;
    border-bottom: none;
    border-right: 1px solid #e4e7ed;
    padding: 10px 6px;
    font-size: 14px;
  }

  .bc-cat:last-child {
    border-right: none;
  }

  .mobile-select {
    display: block;
  }
}
</style>